<template>
  <router-link :class="link_style" :to="path">{{ text }}</router-link>
</template>

<script>
export default {
  name: "SubLink",
  props: {
    link_style: String,
    path: String,
    text: String,
  },
};
</script>

<style scoped>
a {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #2c3e50;
  font-weight: bold;
  text-decoration: none;
}
a::before {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  background-color: #2c3e50;
  transition: width 0.6s cubic-bezier(0.25, 1, 0.5, 1);
}
@media (hover: hover) and (pointer: fine) {
  a:hover::before {
    left: 0;
    right: auto;
    width: 100%;
  }
}
.main-link {
  font-size: 45px;
}
.main-link::before {
  height: 4px;
}
.sub-link {
  font-size: 20px;
}
.sub-link::before {
  height: 2px;
}
</style>